module.exports = __webpack_public_path__ + "img/RegFees-inperson.f710c02f.svg";